import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import {
  addInvitation,
  removeInvitation,
  removeRole,
  removeMember,
  removeItem,
} from '../../utils/circles/circlesActions';

export const consts = createReqConsts('circles', 'caregiver', [
  'REMOVE_ITEM',
  'REMOVE_MEMBER',
  'REMOVE_CAREGIVER',
  'ADD_INVITATION',
  'REMOVE_INVITATION',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'member_caregiver_circles',
  type: 'get',
});

const requestReducer = createReqReducer(consts);

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.REMOVE_ITEM:
      return removeItem(state, payload);
    case consts.REMOVE_MEMBER:
      return removeMember(state, payload);
    case consts.REMOVE_CAREGIVER:
      return removeRole(state, payload, { caregiver: false });
    case consts.ADD_INVITATION:
      return addInvitation(state, payload);
    case consts.REMOVE_INVITATION:
      return removeInvitation(state, payload);

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/circles/caregiver.js